import { buildHref } from "@softmax/web-addresses";
import { createFileRoute, redirect } from "@tanstack/react-router";
import { CreatorRun } from "@/features/coworlds";
import { creatorSearch } from "@/features/coworlds/navigation";

export const Route = createFileRoute("/_site/coworlds/$name/runs/$requestId")({
  validateSearch: creatorSearch,
  beforeLoad: ({ params, search }) => {
    if (!search.version) {
      throw redirect({
        href: buildHref({ name: "coworldManage", coworldName: params.name }),
        statusCode: 307,
        headers: { "Cache-Control": "private, no-store" },
      });
    }

    return { version: search.version };
  },
  component: function CreatorRunPage() {
    const { name, requestId } = Route.useParams();
    const { version } = Route.useRouteContext();
    return <CreatorRun name={name} id={version} requestId={requestId} />;
  },
});
